import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { getUsername, getUserRole } from '../../utils/functions';
import { 
    pushHistoryWithErrorNotFound, 
    pushHistoryWithSignIn, 
    urls 
} from '../../utils/routing';
import { DOCUMENT_TITLE_POSTFIX } from '../../utils/constants';

import Main from '../Main/Main';
import TitleMajor from '../TitleMajor/TitleMajor';
import Back from '../Buttons/Back/Back';
import Information from '../Information/Information';
//import Divider from '../Divider/Divider';
import LinksPanel from '../LinksPanel/LinksPanel';
import UnavailablePageWrapper from '../../containers/UnavailablePageWrapper/UnavailablePageWrapper';
import ModeratorWrapper from '../../containers/AdminWrapper/ModeratorWrapper/ModeratorWrapper';
import UsersWrapper from '../../containers/AdminWrapper/UsersWrapper/UsersWrapper';
//import SupportWrapper from '../../containers/AdminWrapper/SupportWrapper/SupportWrapper';

import { TO_LANDING } from '../../translations';

import { 
    ADMIN_PAGE_TITLE,
    ADMIN_PANEL,
    //ADMIN_PANEL_LINKES,
    ADMIN_PANEL_LOGIN,  
    ADMIN_PANEL_UNAUTHORIZED_MESSAGE, 
    MAIN_ADMIN_PANEL_TITLE 
} from './translations';

import styles from './AdminPanel.module.css'
import CommentsPanelWrapper from '../../containers/AdminWrapper/CommentsPanelWrapper/CommentsPanelWrapper';

export default class AdminPanel extends Component {
    static propTypes = {
        spaId: PropTypes.number,
        spaUsername: PropTypes.string,

        isError: PropTypes.bool,
        isFetching: PropTypes.bool,
        isLoggedIn: PropTypes.bool.isRequired,

        //onShowLoginDialog: PropTypes.func,
    }
    componentDidMount() {
        this.props.onAuthAdmin()

        document.title = ADMIN_PAGE_TITLE+DOCUMENT_TITLE_POSTFIX
    }

    renderTitle = () => {
        return this.props.isLoggedIn && !this.props.isError ? MAIN_ADMIN_PANEL_TITLE : null
    }

    handleLogInClick = () => {
        pushHistoryWithSignIn(this.props.history)
    }

    handlePageClick = (page) => {
        return //pushHistoryWithAdminSection(this.props.history, page)
    }

    renderUrlLinker() {
        var params = window.location.pathname
            .slice(1, -1)
            .split('/')

        return params.length > 1 ? ( <LinksPanel names={params} /> ) : null
    }

    renderInformation = () => {
        return (!this.props.isLoggedIn && !this.props.isError) || this.props.isError ? (
            <Information
                message={ADMIN_PANEL_UNAUTHORIZED_MESSAGE}
                buttonCaption={ADMIN_PANEL_LOGIN}
                onButtonClick={this.handleLogInClick}
            />
        ) : null
    }

    renderError() {
        if (getUsername().spaId === null || getUsername().spaUsername === null) {
            return pushHistoryWithErrorNotFound(this.props.history);
        }
    }

    renderIssues = () => {
        return ADMIN_PANEL.map((item) => {
            return (
                <div className={styles.list_cards_item} key={item.id}>
                    {/*<Link to={urls.adminSection+item.url.slice(1)} className={styles.category_card}>*/}
                    <Link to={{
                        pathname: urls.adminSection+item.url.slice(1),
                        search: '', //"?query=string",
                        hash: '', //"#hash",
                    }} state={{ lastUrl: document.location.href }} className={styles.category_card}>
                        <div className={styles.category_card_mask}>
                            <div className={styles.category_card_name}>
                                <span className={styles.category_card_text}>{item.category}</span>
                            </div>
                            <div className={styles.category_card_icon_wrapper}>
                                <img alt="" className={styles.category_card_icon} src={item.img} />
                            </div>
                        </div>
                    </Link>
                </div>
            )
        })
    }

    renderBody = () => {
        if (this.props.isError || !this.props.isLoggedIn) {
            return
        }
        
        // check for url for current admin page
        if (window.location.pathname === urls.moderatorSection) {
            return (
                <div className="ModeratorWrapper">
                    <ModeratorWrapper {...this.props} />
                </div>
            )
        /*} else if (window.location.pathname.slice(0, 21) === urls.supportSection) {
            return (
                <div>
                    <SupportWrapper {...this.props} />
                </div>
            )*/
        } else if (window.location.pathname === urls.commentsSection) {
            return (
                <div className="CommentsWrapper">
                    <CommentsPanelWrapper {...this.props} />
                </div>
            )
        } else if (window.location.pathname === urls.usersSection) {
            return (
                <div className="UsersWrapper">
                    <UsersWrapper {...this.props} />
                </div>
            )
        } else {
            return (
                <div className="list_cards">
                    {/* <div className={styles.divider}><Divider /></div> */}
                    <div className={styles.list_cards}>{this.renderIssues()}</div>
                </div>
            )
        }
    }

    renderBackButton = () => {
        /*let back;
        if (this.props.location.state && document.location.pathname !== urls.adminSection) {
            back = <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} back={true} />
        } else {
            back = <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} />
        }*/
        return <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} /> //back
    }
    
    render() {
        if ((!window.__URLS__.pages.moderatorSection) && (getUserRole() !== 'admin')) {
            return <UnavailablePageWrapper />
        } else {
            /*const classNameTitle = classNames(styles.title, {
                [styles.isMuted]: this.props.isAuthAdmin || typeof(this.props.isAuthAdmin) !== 'undefined', //this.props.isError || this.props.items.length === 0,
            })*/
            return (
                <Main>
                <div className={styles.base}>
                    <div className={styles.head}>
                        {this.renderBackButton()}
                        <TitleMajor>
                            <span></span>
                            {/* <span className={classNameTitle}>{this.renderTitle()}</span> */}
                            {this.renderUrlLinker()}
                        </TitleMajor>
                    </div>

                    <div style={{position:'relative', marginBottom:'30px'}}><div className={styles.divider_}></div></div>

                    <div className={styles.body}>
                        {/* {this.renderInformation()} */}
                        {this.renderError()}
                        {this.renderBody()}
                    </div>
                </div>
            </Main>
            )
        }
    }
}
